import { render, staticRenderFns } from "./modalPreviewNews.vue?vue&type=template&id=7175395b&scoped=true&"
import script from "./modalPreviewNews.vue?vue&type=script&lang=js&"
export * from "./modalPreviewNews.vue?vue&type=script&lang=js&"
import style0 from "./modalPreviewNews.vue?vue&type=style&index=0&id=7175395b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7175395b",
  null
  
)

export default component.exports